import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';

import ArchiveNotice from './pages/ArchiveNotice';
import LandingPage from './pages/LandingPage';
import LegalResources from './pages/LegalResources';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

const RETIRED_ROUTES = [
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/dashboard',
  '/upload',
  '/chat',
  '/chats',
  '/documents',
  '/templates',
  '/tools',
  '/settings',
] as const;

function ArchiveRedirect() {
  return <Navigate to="/archive" replace />;
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/resources" element={<LegalResources />} />
        <Route path="/archive" element={<ArchiveNotice />} />
        {RETIRED_ROUTES.map((path) => (
          <Route key={path} path={path} element={<ArchiveRedirect />} />
        ))}
        <Route path="/health" element={<ArchiveRedirect />} />
        <Route path="/api" element={<ArchiveRedirect />} />
        <Route path="/api/*" element={<ArchiveRedirect />} />
        <Route path="*" element={<ArchiveRedirect />} />
      </Routes>
    </Router>
  );
}

export default App;
